<template>
  <div class="wrapper">
    <div
      class="createStarterTeam"
      :class="{ colorBg: current === STEPS.STEP2 }"
    >
      <Step0Left
        v-if="current === STEPS.STEP0"
        class="w-[40%] h-full step-0-left"
      />
      <Step1Left v-if="current === STEPS.STEP1" class="w-[40%] h-full" />
      <div class="flex-grow flex flex-col items-center relative pt-[92px]">
        <Steps class="!mb-[82px] steps" :current="current" />
        <Step0Content v-if="current === STEPS.STEP0" @next="nextStep" />
        <Step1Content
          v-if="current === STEPS.STEP1"
          @next="nextStep"
          @account="onAccountGet"
        />
        <Step2Content
          v-if="current === STEPS.STEP2 && starterOrgRes"
          :starter-org-res="starterOrgRes"
          @next="nextStep"
        />
        <Step3Content v-if="current === STEPS.STEP3" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Step1Left from './components/starter/step1/left.vue'
import Step0Content from './components/starter/step0/content.vue'
import Step1Content from './components/starter/step1/content.vue'
import Step2Content from './components/starter/step2/content.vue'
import Step3Content from './components/starter/step3/content.vue'
import Steps from './components/starter/steps/index.vue'
import Step0Left from '~/pages/login/ContentLeft.vue'
import { STEPS, TEAM_STARTER_PAY_ACCOUNT_KEY } from '~/constants/teamCreate'
import type { CreateStarterOrgResponse } from '~/api/interface'
import { useClient } from '~/hooks/useClient'

const route = useRoute()
const router = useRouter()
const session = useSession()

const current = ref<STEPS>(Number(route.query.step) || STEPS.STEP0)

const starterOrgRes = useClient<CreateStarterOrgResponse>(() =>
  sessionGetItem(TEAM_STARTER_PAY_ACCOUNT_KEY)
)

function onAccountGet(info: CreateStarterOrgResponse) {
  sessionSetItem(TEAM_STARTER_PAY_ACCOUNT_KEY, info)
  starterOrgRes.value = info
}

watch(
  () => route.query.step,
  (step) => {
    current.value = Number(step) || STEPS.STEP0
  },
  { immediate: true }
)

watch(
  () => session.value,
  (user) => {
    if (!user?.user_id && current.value !== STEPS.STEP0) {
      router.replace({
        query: { step: STEPS.STEP0 },
        name: route.name as string,
      })
    }
  },
  { immediate: true }
)

function nextStep() {
  router.push({
    query: { step: current.value + 1 },
    name: route.name as string,
  })
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 100vw;
  overflow: auto;
  padding-bottom: 100px;
  background: var(--create-wrapper-bg);
}
.createStarterTeam {
  display: flex;
  width: 100%;
  overflow-x: hidden;
  align-items: center;

  .steps {
    width: min(80%, 800px);
  }
}

.colorBg {
  background: var(--create-bg);
}

.step-0-left {
  transform: translateX(100px);
}
:deep(.ant-steps.ant-steps-small .ant-steps-item-tail) {
  top: -8px;
}
</style>
